<script>
import DidoDownload from "./components/Download.vue";

export default {
  name: "DidoDownloadCe",
  components: {
    DidoDownload,
  },
  props: {
    didoUrl: { type: String, required: true },
    didoWidgetType: { type: String, required: true },
    didoDatasetId: { type: String, required: false, default: void 0 },
    didoDatafileRid: { type: String, required: false, default: void 0 },
    didoDatafileMillesime: { type: String, required: false, default: void 0 },
  },
  emits: [
    "widget-type-unknown",
    "dataset-not-retrieved",
    "datafile-not-retrieved",
    "millesime-not-retrieved",
    "dataset-retrieved",
    "datafile-retrieved",
    "millesime-retrieved",
    "bad-configuration",
  ],
  template: `
    <DidoDownload
      :api-url="didoUrl"
      :widget-type="didoWidgetType"
      :dataset-id="didoDatasetId"
      :datafile-rid="didoDatafileRid"
      :datafile-millesime="didoDatafileMillesime"
      @widget-type-unknown="$emit('widget-type-unknown', $event)"
      @dataset-retrieved="$emit('dataset-retrieved', $event)"
      @dataset-not-retrieved="$emit('dataset-not-retrieved', $event)"
      @datafile-retrieved="$emit('datafile-retrieved', $event)"
      @datafile-not-retrieved="$emit('datafile-not-retrieved', $event)"
      @millesime-retrieved="$emit('millesime-retrieved', $event)"
      @millesime-not-retrieved="$emit('millesime-not-retrieved', $event)"
      @bad-configuration="$emit('bad-configuration')"
    />`,
};
</script>
